import { memo } from "react";
import { formatPrice } from "../utils/scoreFormatter";

/** Selling price, struck-through MRP / list price, and the pack size on cards. */
function PriceDisplay({ pack, size = "small", showPack = true }) {
  if (!pack) return null;
  const large = size === "large";
  return (
    <div className={`ep-price ${large ? "is-large" : ""}`}>
      <span className="ep-price-now">{formatPrice(pack.price)}</span>
      {large && pack.mrp && (
        <span className="ep-price-was">
          <span className="ep-visually-hidden">MRP </span>
          {formatPrice(pack.mrp)}
        </span>
      )}
      {showPack && !large && <span className="ep-price-pack">{pack.label}</span>}
    </div>
  );
}

export default memo(PriceDisplay);
